import { useState } from 'react'
import { Button, Link } from '@mui/material'

import { useRemintProductToken } from 'src/hooks'
import { LinkIcon } from 'src/assets/icons'
import { getPolygonscanNftTokenUrl } from 'src/common/utils'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  arweaveUri: string | null
  isAccountOwner: boolean
  isMinting: boolean
  tokenId: string | null
  notShowNftButton?: boolean
  locale?: string
}

export const ProductScanExplorerButton = ({
  arweaveUri,
  isAccountOwner,
  isMinting,
  tokenId,
  notShowNftButton,
  locale,
}: IProps) => {
  const { mutate: remint, isLoading } = useRemintProductToken(locale)
  const [isRemintButtonDisabled, setIsRemintButtonDisabled] = useState(isLoading || isMinting)
  const classes = useStyles()

  const handleRemint = () => {
    setIsRemintButtonDisabled(true)
    remint()
  }

  return (
    <div className={classes.container}>
      {!notShowNftButton && arweaveUri && tokenId && (
        <Button
          disabled={!arweaveUri || !tokenId}
          component={Link}
          target="_blank"
          href={
            tokenId
              ? getPolygonscanNftTokenUrl(process.env.REACT_APP_PRODUCT_CONTRACT_HASH!, tokenId)
              : '#'
          }
          variant="outlined"
          endIcon={<LinkIcon className={classes.linkIcon} />}
        >
          <HelperWrapper t="product-nft-button-text" isColorInherited verticalPosition={38} />
        </Button>
      )}
      {(!arweaveUri || !tokenId) && isAccountOwner && (
        <Button variant="outlined" onClick={handleRemint} disabled={isRemintButtonDisabled}>
          <HelperWrapper t="remint-nft-button-text" isColorInherited verticalPosition={38} />
        </Button>
      )}
    </div>
  )
}
